import { useMemo } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { getBrowserTimezone, formatDateTime, isValidTimezone } from '@/lib/timezone';

/**
 * Hook that returns the user's timezone and a formatting function.
 * Fallback chain: stored user timezone → browser-detected → 'UTC'.
 */
export function useTimezone() {
  const user = useAuthStore((s) => s.user);

  const timezone = useMemo(() => {
    const stored = user?.timezone;
    if (stored && isValidTimezone(stored)) return stored;
    const browser = getBrowserTimezone();
    if (isValidTimezone(browser)) return browser;
    return 'UTC';
  }, [user?.timezone]);

  const formatTime = useMemo(
    () => (utcString: string, options?: Intl.DateTimeFormatOptions) =>
      formatDateTime(utcString, timezone, options),
    [timezone],
  );

  return { timezone, formatTime };
}
